const ProfileSettingsIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="188"
      height="188"
      viewBox="0 0 188 188"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_814_4861)">
        <path
          d="M97.8531 166.684L39.9838 61.0371L0 74.5691L12.9684 99.7867L12.1472 98.3776L9.71777 99.1842C9.47589 99.2652 9.25438 99.3975 9.06843 99.5721C8.88249 99.7467 8.73651 99.9594 8.64051 100.196C8.54451 100.432 8.50075 100.686 8.51225 100.941C8.52375 101.196 8.59023 101.445 8.70712 101.672L15.1014 114.106C15.509 114.901 16.1591 115.546 16.9575 115.947C17.756 116.348 18.6613 116.484 19.5424 116.336L21.3159 116.04L52.4614 176.606L97.8531 166.684Z"
          fill="black"
        />
        <path
          d="M135.237 15.4219C134.615 15.7617 133.884 15.8411 133.203 15.6425C132.523 15.444 131.949 14.9837 131.608 14.3626L130.126 11.6562L39.9836 61.0371L97.853 166.684L188 117.308L156.495 59.7932C156.155 59.172 156.076 58.4413 156.275 57.7617C156.473 57.0821 156.933 56.5091 157.554 56.1685C157.862 55.9998 158.134 55.7721 158.354 55.4984C158.574 55.2247 158.738 54.9103 158.836 54.5732C158.934 54.2361 158.965 53.883 158.927 53.5339C158.889 53.1848 158.782 52.8467 158.613 52.5389L138.862 16.4811C138.521 15.8604 137.948 15.4002 137.269 15.2016C136.589 15.003 135.858 15.0823 135.237 15.4219Z"
          fill="#85C553"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M139.721 19.3192L66.511 45.417L101.466 143.474L174.676 117.377L139.721 19.3192Z"
          fill="white"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M139.726 19.3241L66.5154 45.4219L79.393 81.5464L152.603 55.4486L139.726 19.3241Z"
          fill="white"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M134.059 56.4362C139.525 52.9657 141.144 45.7206 137.673 40.254C134.202 34.7874 126.957 33.1692 121.491 36.6398C116.024 40.1104 114.406 47.3554 117.877 52.822C121.347 58.2887 128.592 59.9068 134.059 56.4362Z"
          fill="black"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M131.71 57.597C133.335 57.0194 134.813 56.0896 136.037 54.8741C137.261 53.6586 138.201 52.1875 138.79 50.5662C136.754 46.0086 131.778 43.6326 127.298 45.2215C122.818 46.8103 120.472 51.8101 121.779 56.6253C123.26 57.5091 124.919 58.0546 126.636 58.2226C128.353 58.3906 130.085 58.1769 131.71 57.597Z"
          fill="white"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M130.925 48.8141C133.384 46.6411 133.617 42.8858 131.444 40.4262C129.271 37.9667 125.515 37.7344 123.056 39.9073C120.596 42.0803 120.364 45.8356 122.537 48.2952C124.71 50.7547 128.465 50.987 130.925 48.8141Z"
          fill="white"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M103.157 46.8511L77.5359 55.9844L78.585 58.9272L104.206 49.794L103.157 46.8511Z"
          fill="white"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M105.681 53.9215L80.0601 63.0547L81.1091 65.9976L106.73 56.8643L105.681 53.9215Z"
          fill="white"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M107.775 59.8062L82.1545 68.9395L82.6799 70.4132L108.301 61.2799L107.775 59.8062Z"
          fill="black"
        />
        <path
          d="M109.036 63.3423L83.4148 72.4756L83.9401 73.9493L109.561 64.8161L109.036 63.3423Z"
          fill="black"
        />
        <path
          d="M115.44 81.3062L89.8188 90.4395L90.3442 91.9132L115.965 82.7799L115.44 81.3062Z"
          fill="black"
        />
        <path
          d="M116.592 84.5494L90.9707 93.6826L91.4961 95.1563L117.117 86.0231L116.592 84.5494Z"
          fill="black"
        />
        <path
          d="M117.749 87.7867L92.1282 96.9199L92.6535 98.3936L118.274 89.2604L117.749 87.7867Z"
          fill="black"
        />
        <path
          d="M150.189 68.9175L124.568 78.0508L125.094 79.5245L150.715 70.3913L150.189 68.9175Z"
          fill="black"
        />
        <path
          d="M151.347 72.1597L125.726 81.293L126.251 82.7667L151.872 73.6335L151.347 72.1597Z"
          fill="black"
        />
        <path
          d="M152.499 75.399L126.878 84.5322L127.403 86.0059L153.024 76.8727L152.499 75.399Z"
          fill="black"
        />
        <path
          d="M88.1741 87.7167L150.023 65.6768"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M121.423 98.0923L95.8022 107.226L96.3276 108.699L121.948 99.5661L121.423 98.0923Z"
          fill="black"
        />
        <path
          d="M122.576 101.337L96.9551 110.471L97.4804 111.944L123.101 102.811L122.576 101.337Z"
          fill="black"
        />
        <path
          d="M123.733 104.575L98.1125 113.708L98.6379 115.182L124.259 106.048L123.733 104.575Z"
          fill="black"
        />
        <path
          d="M156.174 85.7047L130.553 94.8379L131.078 96.3116L156.699 87.1784L156.174 85.7047Z"
          fill="black"
        />
        <path
          d="M157.331 88.9478L131.71 98.0811L132.235 99.5548L157.856 90.4215L157.331 88.9478Z"
          fill="black"
        />
        <path
          d="M158.484 92.1871L132.863 101.32L133.388 102.794L159.009 93.6608L158.484 92.1871Z"
          fill="black"
        />
        <path
          d="M94.1558 104.505L156.005 82.4648"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M160.792 98.6607L100.122 120.288L105.371 135.012L166.04 113.384L160.792 98.6607Z"
          fill="black"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M130.139 25.3888L58.7068 56.0195L99.7335 151.696L171.166 121.065L130.139 25.3888Z"
          fill="white"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M130.142 25.3898L58.71 56.0205L73.8242 91.2678L145.257 60.6371L130.142 25.3898Z"
          fill="white"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M129.83 59.5713C133.286 54.0956 131.649 46.8548 126.173 43.3985C120.698 39.9423 113.457 41.5794 110.001 47.0551C106.544 52.5308 108.181 59.7716 113.657 63.2278C119.133 66.6841 126.374 65.047 129.83 59.5713Z"
          fill="black"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M124.539 64.0932C126.125 63.4143 127.541 62.3931 128.686 61.1029C129.83 59.8126 130.676 58.2852 131.161 56.6299C128.849 52.2132 123.732 50.1481 119.364 52.0237C114.996 53.8992 112.965 59.0253 114.568 63.7482C116.102 64.5363 117.791 64.9759 119.515 65.0356C121.239 65.0952 122.954 64.7734 124.539 64.0932Z"
          fill="white"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M123.05 55.5121C125.45 53.2734 125.58 49.5132 123.341 47.1133C121.103 44.7135 117.343 44.5828 114.943 46.8215C112.543 49.0602 112.412 52.8205 114.651 55.2203C116.89 57.6201 120.65 57.7508 123.05 55.5121Z"
          fill="white"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M95.3678 55.1583L70.3691 65.8779L71.6004 68.7493L96.5991 58.0297L95.3678 55.1583Z"
          fill="white"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M98.3265 62.0538L73.3279 72.7734L74.5592 75.6448L99.5578 64.9252L98.3265 62.0538Z"
          fill="white"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M100.792 67.798L75.7932 78.5176L76.4098 79.9555L101.408 69.2359L100.792 67.798Z"
          fill="black"
        />
        <path
          d="M102.27 71.2472L77.2712 81.9668L77.8878 83.4047L102.886 72.6851L102.27 71.2472Z"
          fill="black"
        />
        <path
          d="M109.788 88.7755L84.7898 99.4951L85.4064 100.933L110.405 90.2135L109.788 88.7755Z"
          fill="black"
        />
        <path
          d="M111.144 91.9347L86.1453 102.654L86.7619 104.092L111.761 93.3726L111.144 91.9347Z"
          fill="black"
        />
        <path
          d="M112.495 95.1017L87.4963 105.821L88.1129 107.259L113.112 96.5396L112.495 95.1017Z"
          fill="black"
        />
        <path
          d="M143.691 74.2423L118.693 84.9619L119.309 86.3998L144.308 75.6803L143.691 74.2423Z"
          fill="black"
        />
        <path
          d="M145.045 77.3976L120.046 88.1172L120.662 89.5551L145.661 78.8355L145.045 77.3976Z"
          fill="black"
        />
        <path
          d="M146.405 80.5626L121.406 91.2822L122.023 92.7202L147.022 82.0006L146.405 80.5626Z"
          fill="black"
        />
        <path
          d="M82.9753 96.8814L143.323 71.0078"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M116.809 105.157L91.8103 115.877L92.4269 117.315L117.426 106.595L116.809 105.157Z"
          fill="black"
        />
        <path
          d="M118.168 108.313L93.1689 119.032L93.7855 120.47L118.784 109.751L118.168 108.313Z"
          fill="black"
        />
        <path
          d="M119.524 111.478L94.5249 122.197L95.1415 123.635L120.14 112.916L119.524 111.478Z"
          fill="black"
        />
        <path
          d="M150.72 90.6183L125.721 101.338L126.338 102.776L151.336 92.0562L150.72 90.6183Z"
          fill="black"
        />
        <path
          d="M152.074 93.7736L127.075 104.493L127.692 105.931L152.69 95.2115L152.074 93.7736Z"
          fill="black"
        />
        <path
          d="M153.424 96.9406L128.426 107.66L129.042 109.098L154.041 98.3785L153.424 96.9406Z"
          fill="black"
        />
        <path
          d="M89.9958 113.26L150.343 87.3867"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M156.137 103.258L96.9409 128.642L103.101 143.008L162.298 117.624L156.137 103.258Z"
          fill="black"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M113.804 24.7557L48.613 67.0752L105.296 154.392L170.487 112.073L113.804 24.7557Z"
          fill="white"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M113.806 24.7597L48.6152 67.0791L69.4972 99.2467L134.688 56.9273L113.806 24.7597Z"
          fill="white"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M110.347 65.5724C116.738 64.5338 121.078 58.5106 120.039 52.1191C119.001 45.7277 112.977 41.3884 106.586 42.427C100.194 43.4657 95.8552 49.4889 96.8938 55.8803C97.9324 62.2717 103.956 66.611 110.347 65.5724Z"
          fill="black"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M114.859 63.802C116.307 62.8638 117.529 61.6172 118.439 60.1515C119.349 58.6857 119.923 57.037 120.121 55.3232C117.089 51.3584 111.696 50.202 107.711 52.7869C103.727 55.3718 102.59 60.7749 104.976 65.1576C106.621 65.6746 108.361 65.8212 110.069 65.5869C111.778 65.3525 113.414 64.743 114.859 63.802Z"
          fill="#85C553"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M111.054 56.5523C113.552 54.4239 113.852 50.6734 111.724 48.1752C109.595 45.677 105.845 45.3772 103.347 47.5056C100.848 49.634 100.549 53.3846 102.677 55.8827C104.805 58.3809 108.556 58.6807 111.054 56.5523Z"
          fill="white"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M84.5928 59.9993L61.7783 74.8096L63.4795 77.4301L86.2939 62.6199L84.5928 59.9993Z"
          fill="white"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M88.6765 66.2923L65.8621 81.1025L67.5632 83.7231L90.3776 68.9128L88.6765 66.2923Z"
          fill="white"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M91.6727 72.1831L68.8247 86.8711L69.6696 88.1853L92.5176 73.4973L91.6727 72.1831Z"
          fill="black"
        />
        <path
          d="M94.127 74.681L71.3125 89.4912L72.1644 90.8035L94.9789 75.9933L94.127 74.681Z"
          fill="black"
        />
        <path
          d="M104.514 90.6761L81.7 105.486L82.5518 106.799L105.366 91.9884L104.514 90.6761Z"
          fill="black"
        />
        <path
          d="M106.387 93.5658L83.5728 108.376L84.4246 109.688L107.239 94.8781L106.387 93.5658Z"
          fill="black"
        />
        <path
          d="M108.259 96.4544L85.4446 111.265L86.2965 112.577L109.111 97.7667L108.259 96.4544Z"
          fill="black"
        />
        <path
          d="M135.46 70.5872L112.645 85.3975L113.497 86.7098L136.312 71.8995L135.46 70.5872Z"
          fill="black"
        />
        <path
          d="M137.336 73.473L114.522 88.2832L115.374 89.5955L138.188 74.7853L137.336 73.473Z"
          fill="black"
        />
        <path
          d="M139.208 76.3626L116.394 91.1729L117.246 92.4852L140.06 77.6749L139.208 76.3626Z"
          fill="black"
        />
        <path
          d="M79.4771 103.197L134.548 67.4404"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M114.219 105.63L91.4048 120.44L92.2567 121.753L115.071 106.943L114.219 105.63Z"
          fill="black"
        />
        <path
          d="M116.09 108.515L93.2751 123.325L94.127 124.637L116.941 109.827L116.09 108.515Z"
          fill="black"
        />
        <path
          d="M117.965 111.397L95.1509 126.207L96.0028 127.519L118.817 112.709L117.965 111.397Z"
          fill="black"
        />
        <path
          d="M145.165 85.5404L122.35 100.351L123.202 101.663L146.017 86.8527L145.165 85.5404Z"
          fill="black"
        />
        <path
          d="M147.039 88.4222L124.224 103.232L125.076 104.545L147.89 89.7345L147.039 88.4222Z"
          fill="black"
        />
        <path
          d="M148.906 91.3119L126.092 106.122L126.943 107.434L149.758 92.6242L148.906 91.3119Z"
          fill="black"
        />
        <path
          d="M89.1804 118.143L144.251 82.3916"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M152.66 97.08L98.6355 132.15L107.146 145.261L161.171 110.191L152.66 97.08Z"
          fill="black"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M39.9834 61.0372L5.427 34.2842L25.9898 72.8589C26.4757 73.7918 25.1881 73.9667 23.8762 73.1407C22.5497 72.3098 21.2427 72.4944 21.7626 73.4371L32.4278 92.824C32.5973 93.1003 32.8203 93.3398 33.0838 93.5286L38.2925 97.4545C38.5634 97.6457 38.7904 97.8925 38.9582 98.1785L60.5365 139.163L97.8576 166.684L39.9834 61.0372Z"
          fill="#85C553"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.25"
          d="M39.9834 61.0372L5.427 34.2842L25.9898 72.8589C26.4757 73.7918 25.1881 73.9667 23.8762 73.1407C22.5497 72.3098 21.2427 72.4944 21.7626 73.4371L32.4278 92.824C32.5973 93.1003 32.8203 93.3398 33.0838 93.5286L38.2925 97.4545C38.5634 97.6457 38.7904 97.8925 38.9582 98.1785L60.5365 139.163L97.8576 166.684L39.9834 61.0372Z"
          fill="black"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_814_4861">
          <rect width="188" height="188" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ProfileSettingsIcon;
